import React, { useEffect, useState } from "react";
import { getCommonSearchList } from "../../services/settingsServices";
import Select from "react-select";
import { getSerachUserProfile } from "../../services/ClientProfileServices";
import { taskReportPdf } from "../../services/TaskServices";
import { toast } from "react-toastify";
import Utils from "../../utils";

const TaskReport = () => {
  const [taskReportTypeList, setTaskReportTypeList] = useState([]);
  const [taskReportData, setTaskReportData] = useState({
    report_type: "",
    search: "",
    report_type: 1,
    date_from: "",
    date_to: "",
    user_id: "",
    limit: 10,
    page: 1,
  });
  const [userDataList, setUserDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "task_report_type",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTaskReportTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getSerachUserProfile(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setUserDataList(list);
      })
      .catch(() => {});
  }, []);

  const handleSubmitReportDownload = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let data = {
      report_type: taskReportData?.report_type,
      date_from: taskReportData?.date_from,
      date_to: taskReportData?.date_to,
      user_id: taskReportData?.user_id,
      limit: 10,
      page: 1,
    };

    taskReportPdf(data)
      .then((response) => {
        toast.success(response.data.message);
        window.open(response.data.record.url, "_blank");
        setTaskReportData({
          report_type: "",
          search: "",
          report_type: 1,
          date_from: "",
          date_to: "",
          user_id: 0,
          limit: 10,
          page: 1,
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div>
      {" "}
      <div>
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid container-custom-height-new ">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="">
                      <div className="">
                        <div className="card-header">
                          <div className="card-title m-0 d-flex">
                            <div className="row align-items-center">
                              <div className="col-md-3 mb-2">
                                <Select
                                  className="my-Select"
                                  options={taskReportTypeList}
                                  value={taskReportTypeList.find(
                                    (option) =>
                                      option.value ===
                                      Number(taskReportData.report_type)
                                  )}
                                  onChange={(selectedOption) =>
                                    setTaskReportData({
                                      ...taskReportData,
                                      report_type: selectedOption.value,
                                    })
                                  }
                                  placeholder={"Select Report type"}
                                />
                              </div>
                              <div className="col mb-2">
                                <input
                                  type="date"
                                  id="date_from"
                                  className="form-control"
                                  value={taskReportData.date_from}
                                  onChange={(e) => {
                                    setTaskReportData({
                                      ...taskReportData,
                                      date_from: e.target.value,
                                    });
                                  }}
                                ></input>
                              </div>

                              <div className="col mb-2">
                                <input
                                  type="date"
                                  id="date_to"
                                  className="form-control"
                                  value={taskReportData.date_to}
                                  onChange={(e) => {
                                    setTaskReportData({
                                      ...taskReportData,
                                      date_to: e.target.value,
                                    });
                                  }}
                                ></input>
                              </div>

                              <div className="col mb-2">
                                <Select
                                  className="my-Select"
                                  options={userDataList}
                                  value={userDataList.find(
                                    (option) =>
                                      option.value === taskReportData.user_id
                                  )}
                                  onChange={(selectedOption) =>
                                    setTaskReportData({
                                      ...taskReportData,

                                      user_id: selectedOption.value,
                                    })
                                  }
                                  placeholder={"Select UserList"}
                                />
                              </div>
                              <div className="col mb-2">
                                <button
                                  type="button"
                                  className="btn btn-block btn-primary"
                                  style={{ width: "160px" }}
                                  onClick={handleSubmitReportDownload}
                                  disabled={isLoading}
                                >
                                  {isLoading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>{" "}
                                      Loading...
                                    </>
                                  ) : (
                                    <>
                                      Download PDF{" "}
                                      <i className="bi bi-file-earmark-pdf"></i>
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TaskReport;
